<template>
    <div class="position-relative">
        <select v-model="selected" class="custom-select custom-select-sm" :id="id" :disabled="loaded === null">
            <option v-for="result in results" :value="result.werknemer_id">{{result.name}}</option>
        </select> <em class="fa fa-sync fa-spin position-absolute loader" v-show="loaded===null"></em>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                results: [],

                selected: null,

                loaded: null,

                errors: [],

                q: '',
            }
        },
        props: {
            value: [Number, null],
            id: [String]
        },
        watch: {
            results() {
                this.$store.commit('accountmanagersStore/accountmanagers', this.results);
            },
            selected(n, o) {
                this.$emit('input', n);
            },
            value(n, o) {
                this.selected = this.value;
            }
        },
        mounted() {
            if(this.value) {
                this.selected = this.value;
            }
            if(this.$store.getters['accountmanagersStore/accountmanagers'] !== null) {
                this.results = this.$store.getters['accountmanagersStore/accountmanagers'];
                this.loaded = new Date();
            } else {
                this.refresh();
            }
        },
        computed: {
        },
        methods: {
            refresh() {
                this.showing = null;
                this.loaded = null;
                this.errors = [];

                axios.get('/api/v1/leads/ep/accountmanagers')
                    .then(response => {
                        this.loaded = new Date();
                        this.results = response.data;
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
            select(result) {
                this.$emit('input', result);
                this.hide();
            }
        }
    }
</script>

<style lang="scss">
    .loader {
        margin-top: -22px;
        margin-left: 12px;
    }
</style>